import React from 'react';
import birlanuWaterLogo from '../../assets/images/birlanu_water_tank_logo.svg';
import CKALogo from '../../assets/images/CKA Birla_Logo.svg';
import '../../styles/privacyPolicy.css';
// import { Link } from 'react-router-dom';
const TermsOfService = () => {
    return (
        <div className="privacyPolicy">
            <div className="header">
                <div className="logo">
                    <img src={birlanuWaterLogo} alt="BirlaNU Logo" />
                </div>
                {/* <h1>Terms of Service</h1> */}
                <img src={CKALogo} alt="CKA Logo" />
            </div>
            <div className="policyContainer">
                {/* <div className="top-pagination">
                    <ul>
                        <li><Link to="/">Home</Link></li>
                        <li>Terms & Conditions</li>
                    </ul>
                </div> */}
                <h3>Terms & Conditions – BirlaNu Water Tanks</h3>
                <section>
                    <p>These Terms & Conditions (“Terms”) govern your purchase, access, and use of the <strong>BirlaNu Smart Lid Water Tank Monitoring System, mobile application, and related services</strong> (collectively, the “Services”). By using the Smart Lid, you agree to be bound by these Terms. If you do not agree, please do not use the Services.</p>
                </section>
                <section>
                    <h2>1. DEFINITIONS</h2>
                    <ul>
                        <li><strong>“Company”, “We”, “Us”, or “Our”</strong> refers to <strong>BIRLANU LIMITED</strong>(formerly known as HIL Limited), a company governed by the Companies Act, 2013, and having its registered office at 1 & 2, Level 7, SLN Terminus, SY. No 133, Near Botanical Gardens, Gachibowli, Hyderabad, Telangana- 500032 </li>
                        <li><strong>“User”, “You”, or “Your”</strong>means any person who purchases, registers, or uses the Smart Lid and associated Services.</li>
                        <li><strong>“Device”</strong> means the BirlaNu Smart Lid Water Tank Monitoring system.</li>
                    </ul>
                </section>
                <section>
                    <h2>2. ACCEPTANCE OF TERMS</h2>
                    <p>By setting up, accessing, or using the Smart Lid and related app, you acknowledge that you have read, understood, and agreed to these Terms, along with our <strong>Privacy Policy</strong>, which forms an integral part of this agreement.</p>
                </section>
                <section>
                    <h2>3. ELIGIBILITY</h2>
                    <ul>
                        <li>You must be at least <strong>18 years of age</strong> to use the Smart Lid.</li>
                        <li>By using the Services, you represent that you are legally competent to enter into this agreement.</li>
                    </ul>
                </section>
                <section>
                    <h2>4. PRODUCT AND SERVICE USAGE</h2>
                    <ul style={{ listStyleType: "decimal" }}>
                        <li>The Smart Lid is designed for <strong>domestic and commercial water tank monitoring</strong> purposes.</li>
                        <li>You agree not to misuse the device or Services, including but not limited to:
                            <ul style={{ listStyleType: "lower-alpha" }}>
                                <li>Tampering, reverse engineering, or modifying the device.</li>
                                <li>Using the device for unlawful, unauthorized, or harmful purposes.</li>
                                <li>Interfering with security or network systems associated with the Services.</li>
                            </ul>
                        </li>
                    </ul>
                </section>
                <section>
                    <h2>5. USER RESPONSIBILITIES</h2>
                    <ul>
                        <li>You are responsible for maintaining the <strong>confidentiality of your account credentials </strong>(mobile app login).</li>
                        <li>You are responsible for ensuring proper <strong>installation, maintenance, and safe usage</strong> of the device.</li>
                        <li>You must ensure the device is operated under <strong>recommended conditions</strong>(water type, storage, and power supply guidelines).</li>
                    </ul>
                </section>
                <section>
                    <h2>6. SOFTWARE, APP & UPDATES</h2>
                    <ul>
                        <li>The Smart Lid may require a <strong>mobile app </strong>for full functionality.</li>
                        <li>We may release <strong>firmware/software updates </strong>to improve performance or security.</li>
                        <li>By using the Smart Lid, you consent to receiving such updates automatically.</li>
                    </ul>
                </section>
                <section>
                    <h2>7. DATA AND PRIVACY</h2>
                    <ul>
                        <li>Your use of the Smart Lid may involve collection of <strong>water usage data, water temperature, TDS levels, water level, solar battery status, </strong>and other related information.</li>
                        <li>Data collection and usage are governed by our <strong>Privacy Policy </strong>available at [insert link].</li>
                        <li>By using the Services, you consent to such collection, processing, and use.</li>
                    </ul>
                </section>
                <section>
                    <h2>8. WARRANTY & DISCLAIMER</h2>
                    <ul>
                        <li>The Smart Lid comes with a <strong>1-year limited warranty </strong>covering manufacturing defects.</li>
                        <li>The warranty does not cover:
                            <ul>
                                <li>Misuse, improper installation, or unauthorized modifications.</li>
                                <li>Damage caused by natural calamities, accidents, or negligence.</li>
                                <li>Normal wear and tear of components (e.g., batteries).</li>
                            </ul>
                        </li>
                        <li><strong>Disclaimer:</strong> While the Smart Lid provides water monitoring features, it is not a substitute for regular water quality checks. The Company does not guarantee uninterrupted or error-free functioning.</li>
                    </ul>
                </section>
                <section>
                    <h2>9. LIMITATION OF LIABILITY</h2>
                    <p>To the maximum extent permitted by law:</p>
                    <ul>
                        <li>The Company shall not be liable for any <strong>indirect, incidental, special, or consequential damages </strong>arising out of your use of the Smart Lid.</li>
                        <li>Our total liability under these Terms shall not exceed the <strong>purchase price </strong> of the device.</li>
                    </ul>
                </section>
                <section>
                    <h2>10. INTELLECTUAL PROPERTY</h2>
                    <ul>
                        <li>All intellectual property rights in the Smart Lid, app, and related software are owned by <strong>BirlaNu Limited</strong></li>
                        <li>You are granted a <strong>limited, non-exclusive, non-transferable license </strong>to use the app/software solely for personal use with the device.</li>
                    </ul>
                </section>
                <section>
                    <h2>11. TERMINATION</h2>
                    <p>We reserve the right to suspend or terminate your access to the Services if you:</p>
                    <ul>
                        <li>Breach these Terms,</li>
                        <li>Engage in unlawful or fraudulent activity, or</li>
                        <li>Misuse the device or app.</li>
                    </ul>
                </section>
                <section>
                    <h2>12. GOVERNING LAW & DISPUTE RESOLUTION</h2>
                    <ul>
                        <li>These Terms are governed by the laws of <strong>India.</strong></li>
                        <li>Any disputes shall be subject to the exclusive jurisdiction of the <strong>courts in Hyderabad, Telangana, India.</strong></li>
                    </ul>
                </section>
                <section>
                    <h2>13. MODIFICATIONS TO TERMS</h2>
                    <p><strong>BirlaNu Limited </strong> reserves the right to modify or update these Terms from time to time. Updated versions will be posted on our website/app, and continued use of the Services constitutes acceptance of the revised Terms.</p>
                </section>
                <section>
                    <h2>14. CONTACT INFORMATION</h2>
                    <p>For any queries or concerns related to these Terms, please contact:</p>
                    <p><a href="mailto:smarttank.support@birlanu.com">smarttank.support@birlanu.com</a></p>
                    <p>BirlaNu Limited (formerly HIL Limited), Office No 1 & 2, L7 Floor, SLN Terminus, Survey No. 133, Near Botanical Gardens, Gachibowli, Hyderabad, Telangana, India, 500032</p>
                </section>
            </div>
        </div>
    );
};

export default TermsOfService;
